// extracted by mini-css-extract-plugin
export default {"bandeau":"Bandeau_bandeau__s2oKk","info":"Bandeau_info__TBMIx","warning":"Bandeau_warning__JVhNg","error":"Bandeau_error__0yFBG","bandeauIcon":"Bandeau_bandeauIcon__-eD2N"};